"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useClassroomState = void 0;
const useSelector_1 = require("./useSelector");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
function useClassroomState() {
    const stateData = (0, useSelector_1.useSelector)(arModeState => {
        var _a, _b, _c, _d, _e, _f, _g;
        return ({
            isModelPlaced: (_a = arModeState === null || arModeState === void 0 ? void 0 : arModeState.info.isModelPlaced) !== null && _a !== void 0 ? _a : false,
            isExplodeAvailable: (_b = arModeState === null || arModeState === void 0 ? void 0 : arModeState.info.isExplodeAvailable) !== null && _b !== void 0 ? _b : false,
            isScaleAvailable: (_c = arModeState === null || arModeState === void 0 ? void 0 : arModeState.info.isScaleAvailable) !== null && _c !== void 0 ? _c : false,
            isExplodeActive: (_d = arModeState === null || arModeState === void 0 ? void 0 : arModeState.info.isExplodeActive) !== null && _d !== void 0 ? _d : false,
            isScaleHintVisible: (_e = arModeState === null || arModeState === void 0 ? void 0 : arModeState.info.isScaleHintVisible) !== null && _e !== void 0 ? _e : false,
            isClassroomAvailable: arModeState === null || arModeState === void 0 ? void 0 : arModeState.info.classroom,
            classroomState: ((_f = arModeState === null || arModeState === void 0 ? void 0 : arModeState.info.classroom) === null || _f === void 0 ? void 0 : _f.state) || bridge_schema_1.LiveModeClassroomState.Idle,
            hosts: ((_g = arModeState === null || arModeState === void 0 ? void 0 : arModeState.info.classroom) === null || _g === void 0 ? void 0 : _g.hosts) || [],
        });
    });
    const { isClassroomAvailable, classroomState } = stateData;
    const classroomAvailable = isClassroomAvailable &&
        classroomState !== bridge_schema_1.LiveModeClassroomState.StartHosting &&
        classroomState !== bridge_schema_1.LiveModeClassroomState.Hosting &&
        classroomState !== bridge_schema_1.LiveModeClassroomState.StartJoining &&
        classroomState !== bridge_schema_1.LiveModeClassroomState.Joined;
    return Object.assign(Object.assign({}, stateData), { classroomAvailable });
}
exports.useClassroomState = useClassroomState;
